<template>
  <div>
    <div class v-html="compiledMarkdown"></div>
  </div>
</template>

<script>
import marked from "marked";
export default {
  props: ["data"],
  data() {
    return {
      option: {
        baseUrl: null,
        breaks: false,
        gfm: true,
        headerIds: true,
        headerPrefix: "",
        highlight: null,
        langPrefix: "language-",
        mangle: true,
        pedantic: false,
        sanitize: false,
        sanitizer: null,
        silent: false,
        smartLists: false,
        smartypants: false,
        tokenizer: null,
        walkTokens: null,
        xhtml: false,
      },
    };
  },
  // mounted() {},
  computed: {
    compiledMarkdown: function() {
      return marked(this.data, this.option);
    },
  },
};
</script>

<style>

blockquote {
  margin-inline-start: 0px;
  margin-inline-end: 0px;
}

</style>
